module.exports = __webpack_public_path__ + "static/media/learn.c8c900d9.png";